import { DomainEvent } from './DomainEvent'

export class SiteCreated extends DomainEvent {
  readonly eventType = 'site.created' as const
  constructor(
    aggregateId: string,
    public readonly tenantId: string,
    public readonly subdomain: string,
    public readonly name: string,
  ) { super(aggregateId) }
}

export class SitePublished extends DomainEvent {
  readonly eventType = 'site.published' as const
  constructor(aggregateId: string, public readonly tenantId: string) { super(aggregateId) }
}

export class SiteUnpublished extends DomainEvent {
  readonly eventType = 'site.unpublished' as const
  constructor(aggregateId: string, public readonly tenantId: string) { super(aggregateId) }
}
